import React from 'react';

const Vue_Teleport = () => {
  return (
    <div>
      <h1>Vue_Teleport Component</h1>
      <p>This is the Vue_Teleport tutorial page.</p>
    </div>
  );
}

export default Vue_Teleport;
